import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuditTrailItem, AuditTrailShiftType } from '@wilson/api/gateway';
import {
  AuditTrailDrawerState,
  AuditTrailShiftState,
} from '@wilson/audit-trail/states';

@Pipe({
  name: 'auditTrailPreviousAssignedUser',
  standalone: false,
})
export class AuditTrailPreviousAssignedUserPipe implements PipeTransform {
  private readonly store = inject(Store);

  transform(
    currentAuditItem: AuditTrailItem,
    searchedType: AuditTrailShiftType = 'assigned',
  ): string | null | undefined {
    const currentShiftId: string = this.store.selectSnapshot(
      AuditTrailDrawerState.currentShiftId,
    );
    const lastAuditItem: AuditTrailItem | null = this.store.selectSnapshot(
      AuditTrailShiftState.findAuditItemOfSameType(
        currentShiftId,
        currentAuditItem,
        searchedType,
      ),
    );
    return lastAuditItem?.historyDelta.userId;
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [AuditTrailPreviousAssignedUserPipe],
  exports: [AuditTrailPreviousAssignedUserPipe],
})
export class AuditTrailPreviousAssignedUserPipeModule {}
